export const levelsData = [
  {
    value: "novice_low",
    label:
      "Novice Low – Can use isolated words and basic memorized phrases but struggles with communication.",
  },
  {
    value: "novice_mid",
    label:
      "Novice Mid – Can produce simple words and phrases related to personal information but with limited accuracy.",
  },
  {
    value: "novice_high",
    label:
      "Novice High – Can form basic sentences and answer simple questions, though with errors and limited vocabulary.",
  },
  {
    value: "intermediate_low",
    label:
      "Intermediate Low – Can create simple sentences and express basic ideas, but with hesitation and some misunderstandings.",
  },
  {
    value: "intermediate_mid",
    label:
      "Intermediate Mid – Can participate in conversations on familiar topics using connected sentences with more confidence.",
  },
  {
    value: "intermediate_high",
    label:
      "Intermediate High – Can handle more complex conversations with some detail, but may still struggle with accuracy and advanced structures.",
  },
  {
    value: "advanced_low",
    label:
      "Advanced Low – Can express opinions, narrate events in past, present, and future, and sustain conversations with more ease.",
  },
  {
    value: "advanced_mid",
    label:
      "Advanced Mid – Can speak fluently in a variety of situations, using more sophisticated language and details.",
  },
  {
    value: "advanced_high",
    label:
      "Advanced High – Can handle professional and academic discussions with near-native fluency, though occasional errors may still occur.",
  },
];

  export const ProficiencyTooltipContent = () => (
    <div>
      <ul style={{ paddingLeft: 16, margin: 0 }}>
        {levelsData.map((item, index) => (
          <li key={index} style={{ fontSize: 13, marginBottom: 4,textTransform:'capitalize' }}>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );